import { Box, Button, Typography } from '@mui/material'
import styles from './index.module.scss'

export function AppErrorBoundaryFallbackView({ error, onReload }) {
  return (
    <Box component="div" className={styles.wrap} role="alert">
      <Typography component="h1" className={styles.title} variant="h5">
        Something went wrong
      </Typography>
      <Typography component="p" className={styles.body} variant="body1">
        The application hit an unexpected error. You can try reloading the page. If the problem
        persists, contact support and include the time this occurred.
      </Typography>
      {import.meta.env.DEV ? (
        <Box component="pre" className={styles.detail}>
          {error?.message ?? String(error)}
        </Box>
      ) : null}
      <Button
        type="button"
        variant="contained"
        color="primary"
        disableElevation
        className={styles.button}
        onClick={onReload}
      >
        Reload page
      </Button>
    </Box>
  )
}
